import { LocaleMessages } from 'vue-i18n';

const i18n: LocaleMessages = {
  app: {
    contactBanner: {
      title: 'S Elixírem cestujete vždy výhodněji',
      subtitle:
        'Svěřte se nám, o čem sníte. Naši travel specialisté připraví nabídku podle Vašich představ.',
      button: 'Kontaktujte nás',
    },
  },
};

export default i18n;
